// Assessment overview section form field enum
export enum AssessmentOverviewFormField {
  APPOINTMENT_TIME = 'assessmentOverview/appointmentTime',
  REASON_FOR_DOCUMENTATION = 'assessmentOverview/reasonForDocumentation',
  IN_PERSON = 'assessmentOverview/inPerson',
  EFFECTIVE_DATE = 'assessmentOverview/effectiveDate',
  REVISABLE_CARE_PLAN = 'assessmentOverview/revisableCarePlan'
}
